import { Box, Typography, DialogActions, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import {
  Button,
  FormWithRedirect,
  RadioButtonGroupInput,
  SaveButton,
} from 'react-admin';
import useStyles from '../../QuickActions/styles';
import { shouldDisplayVehicleType } from '../../VehicleConstants';

const VehicleLabel = ({ record }) => {
  const classes = useStyles();

  const {
    display_name,
    license_plate_number,
    license_plate_state,
    vin,
    type,
  } = record;

  const isMultiline =
    vin ||
    shouldDisplayVehicleType() ||
    license_plate_number ||
    license_plate_state;

  return (
    <div className={isMultiline ? classes.multilineVehicleLabel : ''}>
      <Typography>{display_name}</Typography>
      {(license_plate_number || license_plate_state) && (
        <Typography className={classes.typography} style={{ fontSize: '12px' }}>
          {[license_plate_number, license_plate_state]
            .filter(Boolean)
            .join(' ')}
        </Typography>
      )}
      {vin && (
        <Typography className={classes.typography} style={{ fontSize: '12px' }}>
          {vin}
        </Typography>
      )}
      {shouldDisplayVehicleType() && (
        <Typography className={classes.typography} style={{ fontSize: '12px' }}>
          {type}
        </Typography>
      )}
    </div>
  );
};

const VehicleListSelection = ({
  vehicleList,
  setVehicle,
  setIsAddingVehicle,
  vehicleData,
  onSelectVehicle,
  onSaveSelectedVehicle,
  onSkip,
}) => {
  const classes = useStyles();

  // vehicleCount tracks how many vehicles to show on the page
  const [vehicleCount, setVehicleCount] = useState(3);
  const [isSaving, setIsSaving] = useState(false);

  const handleAddNew = () => {
    setVehicle(null);
    setIsAddingVehicle(true);
  };

  const handleSubmit = async () => {
    setIsSaving(true);
    const res = await onSaveSelectedVehicle();
    Promise.resolve(res).then(() => {
      setIsSaving(false);
    });
  };

  const addNewButton = (
    <Grid item xs>
      <Button onClick={handleAddNew} label="Add new">
        <AddIcon />
      </Button>
    </Grid>
  );

  if (!vehicleList.length) {
    return addNewButton;
  }

  return (
    <>
      <FormWithRedirect
        resource="customer"
        record={vehicleData}
        render={() => (
          <>
            <Grid container direction="column">
              <Grid item xs className={classes.hideHelperText}>
                <RadioButtonGroupInput
                  row={false}
                  source="vehicle_id"
                  choices={vehicleList.slice(0, vehicleCount)}
                  onChange={onSelectVehicle}
                  optionText={<VehicleLabel />}
                />
              </Grid>
              <Grid item xs>
                {vehicleCount < vehicleList.length && (
                  <>
                    <Button
                      label="Show more"
                      onClick={() =>
                        setVehicleCount((prevState) => prevState + 5)
                      }
                    >
                      <ExpandMoreIcon />
                    </Button>
                    <Button
                      label="Show all"
                      onClick={() => setVehicleCount(vehicleList.length)}
                      className={classes.showAllButton}
                    >
                      <ExpandMoreIcon />
                    </Button>
                  </>
                )}
              </Grid>
            </Grid>
            {addNewButton}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              width="100%"
            >
              <DialogActions>
                {!!vehicleData && (
                  <SaveButton
                    label="Continue"
                    handleSubmitWithRedirect={handleSubmit}
                    saving={isSaving}
                    className={classes.buttonWithoutIcon}
                  />
                )}
                {onSkip && <Button onClick={onSkip} label="Skip" />}
              </DialogActions>
            </Box>
          </>
        )}
      />
    </>
  );
};

export default VehicleListSelection;
